import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { ArrowRight, Loader2 } from "lucide-react";

export default function Start() {
  const [countries, setCountries] = useState([]);
  const [form, setForm] = useState({ name: "", email: "", location: "", country_code: "IN" });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => { api.countries().then(setCountries).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.location) {
      toast.error("Please fill in every field");
      return;
    }
    setLoading(true);
    try {
      const { user } = await api.createUser(form);
      login(user);
      toast.success(`Welcome, ${user.name.split(" ")[0]}!`);
      navigate(user.subscribed ? "/dashboard" : "/checkout");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full px-4 py-3 rounded-xl border border-[#E8E1D9] bg-white focus:outline-none focus:border-[#6B21A8] focus:ring-2 focus:ring-[#6B21A8]/15 transition";

  return (
    <div className="max-w-md mx-auto px-5 py-16 fade-up">
      <h1 className="font-display text-3xl font-bold text-[#2B2625] mb-2">Let's begin with you</h1>
      <p className="text-[#6E655F] mb-8">Just a few details — no passwords, no fuss.</p>
      <form onSubmit={submit} className="bg-white border border-[#E8E1D9] rounded-2xl p-7 shadow-sm space-y-4">
        <div>
          <label className="text-sm font-semibold text-[#2B2625] block mb-1.5">Your name</label>
          <input data-testid="start-name" className={field} value={form.name}
                 onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="e.g. Priya Sharma" />
        </div>
        <div>
          <label className="text-sm font-semibold text-[#2B2625] block mb-1.5">Email</label>
          <input data-testid="start-email" type="email" className={field} value={form.email}
                 onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="you@example.com" />
        </div>
        <div>
          <label className="text-sm font-semibold text-[#2B2625] block mb-1.5">City / Location</label>
          <input data-testid="start-location" className={field} value={form.location}
                 onChange={(e) => setForm({ ...form, location: e.target.value })} placeholder="e.g. Bengaluru" />
        </div>
        <div>
          <label className="text-sm font-semibold text-[#2B2625] block mb-1.5">Country</label>
          <select data-testid="start-country" className={field} value={form.country_code}
                  onChange={(e) => setForm({ ...form, country_code: e.target.value })}>
            {countries.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
          </select>
        </div>
        <button
          data-testid="start-submit" type="submit" disabled={loading}
          className="w-full inline-flex items-center justify-center gap-2 bg-[#6B21A8] hover:bg-[#4C1D95] text-white font-semibold py-3.5 rounded-xl transition-colors active:scale-[0.98] disabled:opacity-60"
        >
          {loading ? <Loader2 className="animate-spin" size={18} /> : <>Continue <ArrowRight size={18} /></>}
        </button>
      </form>
    </div>
  );
}
